import React from 'react';
import { Box, Typography, TextField, IconButton, CircularProgress } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';

const WebhookSuccessModal = ({ formData, isLoading }) => {
  const dispatch = useDispatch();

  if (isLoading) {
    return (
      <Box height={260} display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap={2}>
        <CircularProgress />
        <Typography color="gray">Creating webhook...</Typography>
      </Box>
    );
  }

  const copyToClipboard = async (text, label) => {
    try {
      await navigator.clipboard.writeText(text);
      dispatch(
        showSnackbar({
          message: `${label} has been copied to clipboard`,
          severity: 'success',
        }),
      );
    } catch (error) {
      dispatch(
        showSnackbar({
          message: 'Failed to copy to clipboard',
          severity: 'error',
        }),
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          background: 'rgba(16, 185, 129, 0.12)',
          border: '1px solid rgba(16, 185, 129, 0.4)',
          borderRadius: 2,
          p: 2,
          mb: 3,
          display: 'flex',
          gap: 2,
          alignItems: 'flex-start',
        }}
      >
        <ShieldOutlinedIcon sx={{ color: '#22c55e', mt: 0.3 }} />

        <Box>
          <Typography sx={{ color: '#22c55e', fontWeight: 600 }}>Webhook Created Successfully</Typography>
          <Typography variant="body2" sx={{ color: '#9ca3af' }}>
            Your webhook endpoint has been configured and is ready to receive events.
          </Typography>
        </Box>
      </Box>

      <Typography mb={1} fontWeight={500}>
        Signing Secret
      </Typography>

      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <TextField
          fullWidth
          value={formData.signingSecret}
          InputProps={{
            readOnly: true,
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              background: '#1f2937',
              borderRadius: 2,
              '& fieldset': {
                borderColor: '#374151',
              },
            },
            input: { color: '#e5e7eb' },
          }}
        />

        <IconButton
          onClick={() => copyToClipboard(formData.signingSecret, 'Signing Secret')}
          sx={{
            border: '1px solid #374151',
            borderRadius: 2,
            height: 45,
            width: 45,
            color: '#e5e7eb',
          }}
        >
          <ContentCopyIcon />
        </IconButton>
      </Box>

      <Box
        sx={{
          background: '#1f2937',
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography fontWeight={600} mb={2}>
          Webhook Details
        </Typography>

        <Typography variant="body2" color="gray">
          Name: {formData.name}
        </Typography>

        <Typography variant="body2" color="gray">
          URL: {formData.url}
        </Typography>

        <Typography variant="body2" color="gray">
          Business Profiles: {formData.businessProfiles.length} selected
        </Typography>

        <Typography variant="body2" color="gray">
          Events: {formData.events.length} event type(s)
        </Typography>
      </Box>
    </>
  );
};

export default WebhookSuccessModal;
